/**
 * 一鍵加入 / 補資料 共用小工具(2026-09-24)
 *
 * 流程:Splash → 非會員導 /join(一顆「同意條款並加入」)→ /home;
 *       結帳 / 送禮前若還沒留姓名 + 手機 → /complete-profile?next=<原頁> → 補完回原頁。
 */
import type { Member } from "../api/members";

/**
 * `?next=` 安全性:只允許 site-relative path(`/...`),不接受 `//`(protocol-relative
 * 會被當外站)、protocol scheme、或缺前綴的 relative path。防 open redirect。
 */
export function safeNext(raw: string | null): string | null {
  if (!raw) return null;
  if (!raw.startsWith("/")) return null;
  if (raw.startsWith("//")) return null;
  return raw;
}

/** 結帳 / 送禮前要有的欄位還沒齊(姓名、手機)。對齊後端 member_service.profile_missing。 */
export function needsProfile(m: Member | null | undefined): boolean {
  if (!m) return false; // 還沒載入就先不判,載入後再說(避免一進頁就被彈走)
  return !(m.name || "").trim() || !(m.phone || "").trim();
}

/** 組 `path?next=<回去的頁>`,next 一律 encode。 */
export function withNext(path: string, next: string): string {
  return `${path}?next=${encodeURIComponent(next)}`;
}

/** 從 location.search 取回安全的 next,沒有就用 fallback。 */
export function nextFromSearch(search: string, fallback: string): string {
  return safeNext(new URLSearchParams(search).get("next")) || fallback;
}
